<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-orange">
  <button class="navbar-toggler " type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03"
    aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <a class="navbar-brand" [routerLink]="['/Home']" [routerLinkActive]="['Active']" href="#">
    <img src="./assets/img/logo blanco satlock.png" alt="">
  </a>
  <div class="collapse navbar-collapse" id="navbarTogglerDemo03">

    <ul class="navbar-nav mr-auto mt-2 mt-lg-0" [ngSwitch]="idiomaB">
      <!-- Ingles -->
      <ng-container *ngSwitchCase="'2'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">Video</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">D2D platform access</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">Contact us</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Language</a>
        </li>
      </ng-container>
      <!-- Chino -->
      
      <ng-container *ngSwitchCase="'3'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> 家 <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">視頻</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">D2D平台访问</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">聯繫我們</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">语言</a>
        </li>
      </ng-container>
      <!-- Frances -->
      <ng-container *ngSwitchCase="'4'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> Début <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">Vidéo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">Accès à la plateforme
            D2D</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">Nous contacter</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Langue</a>
        </li>
      </ng-container>
      <!-- Aleman -->
      <ng-container *ngSwitchCase="'5'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> Anfang <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">Videos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">Zugang zur
            D2d-Plattform</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">kontaktiere uns</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Sprache</a>
        </li>
      </ng-container>
      <!-- Ruso -->
      <ng-container *ngSwitchCase="'6'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> Начало <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">видео</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">Доступ к платформе D2D</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">Связаться с нами</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Язык</a>
        </li>
      </ng-container>
      <!-- Portugués Brasil -->
      <ng-container *ngSwitchCase="'7'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home">Início<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">Vídeos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">Acesso à plataforma D2D</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">Entre em contato conosco</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Línguas</a>
        </li>
      </ng-container>
      <!-- Coreano -->
      <ng-container *ngSwitchCase="'8'">
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home">홈<span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">동영상</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">D2D 플랫폼 액세스</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">문의</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">언어들</a>
        </li>
      </ng-container>
      <!-- Español -->
      <ng-container *ngSwitchDefault>
        <li class="nav-item ">
          <a class="nav-link bg-orange home" href="#" [routerLink]="['/Home']" [routerLinkActive]="['Active']"
            id="home"> Inicio <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/videos']" [routerLinkActive]="['Active']"
            id="br1">Videos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="https://www.satlockonline.com/d2dweb" id="br2">Acceso Plataforma D2D</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" href="#" [routerLink]="['/contactos']" [routerLinkActive]="['Active']"
            tabindex="-1" aria-disabled="true" id="br2">Contáctanos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link bg-orange" type="button" data-toggle="modal" data-target="#exampleModalCenter">Idiomas</a>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header" [ngSwitch]="idiomaB">
        <ng-container *ngSwitchCase="2">
          <h5 class="modal-title" id="exampleModalLongTitle">Select a language</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <h5 class="modal-title" id="exampleModalLongTitle">選擇一種語言</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <h5 class="modal-title" id="exampleModalLongTitle">Sélectionnez une langue</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="5">
          <h5 class="modal-title" id="exampleModalLongTitle">Wähle eine Sprache</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="6">
          <h5 class="modal-title" id="exampleModalLongTitle">Выберите язык-</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="7">
          <h5 class="modal-title" id="exampleModalLongTitle">Selecionar idioma</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="8">
          <h5 class="modal-title" id="exampleModalLongTitle">언어 선택</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <h5 class="modal-title" id="exampleModalLongTitle">Seleccione idioma</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ng-container>
      </div>
      <div class="modal-body">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
          <div class="row d-flex justify-content-between align-self-center contenTB">
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(1)"><img src="assets/img/idiomasImg/bandera1.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">ES</span>
              </a>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(2)"><img src="assets/img/idiomasImg/bandera2.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">EN</span>
              </a>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(3)"><img src="assets/img/idiomasImg/bandera3.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">ZH</span>
              </a>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-self-center contenTB">
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(4)"><img src="assets/img/idiomasImg/bandera4.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">FR</span>
              </a>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(5)"><img src="assets/img/idiomasImg/bandera5.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">DE</span>
              </a>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(6)"><img src="assets/img/idiomasImg/bandera6.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">RU</span>
              </a>
            </div>
          </div>
          <div class="row d-flex justify-content-between align-self-center contenTB">
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(7)"><img src="assets/img/idiomasImg/bandera7.jpg"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">BR</span>
              </a>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
              <a type="button" (click)="sendEvent(8)"><img src="assets/img/idiomasImg/bandera8.png"
                  data-dismiss="modal" class="bandera" alt="">
                <span class="">KR</span> 
              </a> 
            </div>
            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-4 col-4">
             
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>